var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhatsNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 1H2.55556C1.7 1 1 1.7 1 2.55556V13.4444C1 14.3 1.7 15 2.55556 15H13.4444C14.3 15 15 14.3 15 13.4444V4.88889L11.1111 1ZM13.4444 13.4444H2.55556V2.55556H10.3333V5.66667H13.4444V13.4444ZM4.11111 11.8889H11.8889V10.3333H4.11111V11.8889ZM8 4.11111H4.11111V5.66667H8V4.11111ZM4.11111 8.77778H11.8889V7.22222H4.11111V8.77778Z",
    fill: "#E5E4EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsNew);
export default __webpack_public_path__ + "static/media/icon-whats-new.e096d6b95b41a55881ff4dc5fcd0a726.svg";
export { ForwardRef as ReactComponent };